import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// core version + navigation, pagination modules:

import Swiper, { Navigation, Autoplay, EffectFade, Controller } from 'swiper';
// import Swiper and modules styles
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';	

function swiperTestimonialSlider() {
    
    const testimonialSliderName = new Swiper('.swiper-testimonial-slider-name', {

        modules: [Navigation, Autoplay, EffectFade, Controller ],
        loop: true,
        slidesPerView: 1,
        slidesPerGroup: 1,
        slidesPerColumn: 1,
        spaceBetween: 0,
        speed: 1000,
    });

    const testimonialSliderContent = new Swiper('.swiper-testimonial-slider-content', {

        modules: [Navigation, Autoplay, EffectFade, Controller ],
        loop: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            },
        slidesPerView: 1,
        slidesPerGroup: 1,
        slidesPerColumn: 1,
        spaceBetween: 40,
        speed: 1000,
    });

    // connect sliders
    testimonialSliderContent.controller.control = testimonialSliderName;
    testimonialSliderName.controller.control = testimonialSliderContent;

    if(document.querySelector('.block--testimonial-slider')) {
          
        testimonialSliderContent.on('slideChange', function () {
            var currentSlide = document.querySelector('.swiper-testimonial-slider-content .swiper-slide-active');  
            if(currentSlide.querySelector('.popup-button')) {                    
                currentSlide.querySelector('.popup-button').style.opacity = 0;
            }
        });
        testimonialSliderContent.on('slideChangeTransitionEnd', function() { 
            var thisSwiper = document.querySelector('.swiper-testimonial-slider-content') ;
            var newSlide = thisSwiper.querySelector('[data-swiper-slide-index="' + testimonialSliderContent.realIndex + '"]');

            if(newSlide.querySelector('.popup-button')) {
                newSlide.querySelector('.popup-button').style.opacity = 1;
            }
        })

        if(window.innerWidth < 768) {
            var buttonOpacityOpen = 0;
        } else {
            var buttonOpacityOpen = 1;
        }

        if(window.innerWidth < 768) {
            var buttonOpacityClose = 1;
        } else {
            var buttonOpacityClose = 1;
        }

        var popupOpenButton = document.querySelectorAll('.slide-open-content');        
        [...popupOpenButton].forEach((button) => {
            var thisBlock = document.querySelector('.block--testimonial-slider') ;
            var thisSlide = button.closest('.swiper-slide');
            button.addEventListener('click', () => {
                let testemonialTimeline = gsap.timeline();
                testemonialTimeline
                .to(thisBlock.querySelector('.slider-gradient'), {
                    opacity: 0,
                    duration: 0.2
                })
                .to(button, {
                    opacity: buttonOpacityOpen,
                    duration: 0.2
                }, "<")
                .to(thisBlock.querySelectorAll('.js-slide-hide '), {
                    opacity: 0,
                    duration: 0.2
                }, "<")
                .to(thisBlock.querySelector('.swiper-navigation '), {
                    opacity: 0,
                    duration: 0.2
                }, "<")
                .to(thisSlide.querySelector('.card'), {
                    rotateY: "180deg",
                    duration: 0.4
                }, ">")
                .to(thisSlide.querySelector('.slide-close'), {
                    opacity: 1,
                    duration: 0.2
                }, "<")
            })
            
            var closeButton = thisSlide.querySelector('.slide-close');
            closeButton.addEventListener('click', () => {
                let testemonialTimelineClose = gsap.timeline();
                testemonialTimelineClose
                .to(thisSlide.querySelector('.card'), {
                    rotateY: "0",
                    duration: 0.4
                })
                .to(thisSlide.querySelector('.slide-close'), {
                    opacity: 0,
                    duration: 0.2
                }, "<")
                .to(button, {
                    opacity: buttonOpacityClose,
                    duration: 0.2
                }, "<+=0.3")
                .to(thisBlock.querySelectorAll('.js-slide-hide '), {
                    opacity: 1,
                    duration: 0.2
                }, "<")
                .to(thisBlock.querySelector('.swiper-navigation '), {
                    opacity: 1,
                    duration: 0.2
                }, "<")
                .to(thisBlock.querySelector('.slider-gradient'), {
                    opacity: 1,
                    duration: 0.2
                }, ">")
 
            })
        })
        
    }

}

export default swiperTestimonialSlider;